import React from 'react';
import { CalendarCheck, CheckCircle2, MessageCircle, ShieldCheck } from 'lucide-react';

interface Props {
  codigo: string;
  whatsappNumber?: string | null;
  whatsappUrl?: string | null;
  serviceName?: string;
  branchName?: string;
  dateLabel?: string;
  timeLabel?: string | null;
  onNewRequest: () => void;
  onViewRequests: () => void;
}

const branchPhone = (value?: string | null) => {
  const digits = (value || '').replace(/\D/g, '').replace(/^00/, '');
  return digits.length === 8 ? `591${digits}` : digits;
};
const phoneFromUrl = (value?: string | null) => {
  if (!value) return '';
  try {
    const url = new URL(value);
    return url.hostname === 'wa.me' ? branchPhone(url.pathname) : '';
  } catch { return ''; }
};

const ReservationRequestSuccess: React.FC<Props> = ({
  codigo,
  whatsappNumber,
  whatsappUrl,
  serviceName,
  branchName,
  dateLabel,
  timeLabel,
  onNewRequest,
  onViewRequests,
}) => {
  const phone = branchPhone(whatsappNumber) || phoneFromUrl(whatsappUrl);
  const message = [
    'Hola Co Marca, deseo oficializar mi solicitud de reserva.',
    `Código: ${codigo}`,
    serviceName ? `Servicio: ${serviceName}` : '',
    branchName ? `Sucursal: ${branchName}` : '',
    dateLabel ? `Fecha: ${dateLabel}${timeLabel ? ` a las ${timeLabel}` : ''}` : '',
  ].filter(Boolean).join('\n');
  const whatsappHref = phone
    ? `https://wa.me/${phone}?text=${encodeURIComponent(message)}`
    : null;

  return (
    <div className="booking-success" style={{ textAlign: 'center', background: '#fff', borderRadius: 22, border: '1.5px solid #f1f5f9', boxShadow: '0 4px 32px rgba(0,0,0,.06)', padding: 'clamp(36px,6vw,64px) 28px' }}>
      <div style={{ width: 72, height: 72, borderRadius: '50%', background: '#edf7ff', border: '1px solid #dcecf8', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
        <ShieldCheck size={36} color="#007fc8" />
      </div>
      <h2 style={{ fontSize: 'clamp(1.35rem,2.5vw,1.9rem)', fontWeight: 900, color: '#0f172a', marginBottom: 8 }}>
        Solicitud pendiente de validación
      </h2>
      <p style={{ color: '#64748b', maxWidth: 560, margin: '0 auto 22px', lineHeight: 1.65 }}>
        Tu solicitud todavía <strong>no es una reserva oficial</strong>. Envía este código por WhatsApp a Co Marca para que el personal revise la disponibilidad y confirme tu reserva.
      </p>
      <div aria-label="Código de solicitud" style={{ display: 'inline-flex', alignItems: 'center', gap: 10, background: '#f8fafc', border: '2px dashed #94a3b8', borderRadius: 14, padding: '14px 22px', marginBottom: 22 }}>
        <CheckCircle2 size={18} color="#007fc8" />
        <strong style={{ fontSize: '1.25rem', letterSpacing: '.06em', color: '#0f172a' }}>{codigo}</strong>
      </div>
      {phone && <p className="booking-whatsapp-branch">{branchName || 'Sucursal'} · WhatsApp +{phone}</p>}
      <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 12 }}>
            {whatsappHref ? (
              <a className="booking-whatsapp-button" href={whatsappHref} target="_blank" rel="noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'linear-gradient(135deg, #FF2052, #9B004A)', color: '#fff', padding: '11px 18px', borderRadius: 12, textDecoration: 'none', fontWeight: 800, boxShadow: '0 5px 18px rgba(255, 32, 82, .22)' }}>
                <MessageCircle size={17} /> Enviar código por WhatsApp
              </a>
            ) : null}
            <button onClick={onViewRequests} style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: '#007fc8', color: '#fff', padding: '11px 18px', borderRadius: 12, border: 0, fontWeight: 800, cursor: 'pointer' }}>
              <CalendarCheck size={16} /> Ver mis solicitudes
            </button>
            <button onClick={onNewRequest} style={{ background: '#fff', color: '#FF2052', padding: '10px 17px', borderRadius: 12, border: '1.5px solid rgba(255, 32, 82, .35)', fontWeight: 800, cursor: 'pointer' }}>
              Nueva solicitud
            </button>
      </div>

    </div>
  );
};

export default ReservationRequestSuccess;


